if (!customElements.get("footer-details")) {
	class FooterDetails extends AccordionDetails {
		constructor() {
			super();
		}

		connectedCallback() {
			this.openDefault = this.dataset.openDefault === 'true';

			if (FoxTheme.config.mqlTablet) {
				if (!this.openDefault) this.open = false;
			}

			document.addEventListener('matchTablet', () => {
				if (!this.openDefault) {
					this.open = false;
				} else {
					this.open = true;
				}
			});

			document.addEventListener('unmatchTablet', () => {
				this.open = true;
			});
		}
	}
	customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

//YD_FIX: API Reviews.io
const apiUrl = 'https://api.reviews.io/merchant/latest?store=nvs-pharmacy';

fetch(apiUrl)
	.then(response => {
		if (!response.ok) {
			throw new Error(`Network response was not ok: ${response.status}`);
		}
		return response.json();
	})
	.then(data => {
		// Assuming 'stats' is a property in the returned JSON
		const statsTotalReview = data.stats.total_reviews;
		const statsAvgRating = data.stats.average_rating;
		const statsWord = data.word;
		//const statsRating = data.excellent_percentage;
		// Now you can use the 'statsValue' variable as needed
		//console.log('Stats Value:', statsValue);
		//document.getElementById('reviewStar').innerHTML = statsRating;
		var reviewOutput = " <span class='hidden-xs'>100% Genuine Products</span><span class='topsep'>|</span><span class='reviewblock'>" + statsWord + " <b class='text-light-green'>★★★★★</b> " + statsAvgRating + " out of 5, " + statsTotalReview + " Reviews </span><span class='topsep'>|</span><span class='hidden-xs'>UK Standard Delivery - £3.49</span>";
		document.getElementById('reviewOutput').innerHTML = reviewOutput;
	})
	.catch(error => {
		console.error('Fetch error:', error);
	});

    reviewsBadgeModern('nvs_reviewsio', {
		store: 'nvs-pharmacy',
		primaryClr: '#008064',
		starsClr: '#8cc63f'
    });

	/* reviewsBadgeRibbon("nvs_reviewsio", {
        store: "nvs-pharmacy",
        size: "small", 
    }); */


document.addEventListener("DOMContentLoaded", function () {
    var divs = Array.from(document.querySelectorAll("#faq dd"));
    divs.forEach(function (div) {
        div.style.display = "none";
    });

    var h2s = Array.from(document.querySelectorAll("#faq dt"));
    h2s.forEach(function (h2) {
        h2.addEventListener("click", function () {
            h2s.forEach(function (otherH2) {
                if (otherH2 !== h2) {
                    otherH2.classList.remove("active");
                }
            });

            h2.classList.toggle("active");

            divs.forEach(function (div) {
                if (div !== h2.nextElementSibling) {
                    div.style.display = "none";
                }
            });

            h2.nextElementSibling.style.display =
                h2.nextElementSibling.style.display === "none" ? "block" : "none";

            return false; // Prevent the browser jump to the link anchor
        });
    });
});


// The speed of the scroll in milliseconds
 document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute("href"));

    if (target) {
      target.scrollIntoView({
        behavior: "smooth"
      });
    }
  });
});